import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { CurrentUserBuildingPermissionResponse } from '@quipex/shared/contracts';
import { UserBuildingStore } from '../user-building';

export interface UserBuildingGuardCheckOptions {
    check: (permission: CurrentUserBuildingPermissionResponse) => boolean;
    redirectTo?: string[];
}

export function createUserBuildingPermissionGuard(
    options: UserBuildingGuardCheckOptions
) {
    const router = inject(Router);
    const userBuildingStore = inject(UserBuildingStore);
    const permission = userBuildingStore.permissionForNavigation();
    const currentBuildingId =
        permission?.buildingId ?? userBuildingStore.currentBuildingId();
    const redirectPath =
        options.redirectTo ??
        (currentBuildingId
            ? ['/buildings', currentBuildingId]
            : ['/buildings']);

    if (!permission) {
        return router.createUrlTree(redirectPath);
    }

    return options.check(permission)
        ? true
        : router.createUrlTree(redirectPath);
}
